import VoerroTagsInput from './VoerroTagsInput.vue'

window.VoerroTagsInput = VoerroTagsInput;

export default VoerroTagsInput;


// WEBPACK FOOTER //
// ./src/main.js